import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

// Palette contains in each row the maximum altitude, R,G,B color, and legend text

/*
# QGIS Generated Color Map Export File
INTERPOLATION:DISCRETE
0.01,215,25,28,255,<= 0,0100
0.4,253,174,97,255,0,0100 - 0,4000
1,255,255,191,255,0,4000 - 1,0000
2.5,171,221,164,255,1,0000 - 2,5000
inf,43,131,186,255,> 2,5000
*/

const palette = [
  [-0.0001, 255, 255, 255, 0, "No data"], // special case for no data
  [0.01, 215, 25, 28, 255, "<= 0.01 m"],
  [0.4, 253, 174, 97, 255, "0.01 - 0.4 m"],
  [1, 255, 255, 191, 255, "0.4 - 1.0 m"],
  [2.5, 171, 221, 164, 255, "1.0 - 2.5 m"],
  [Infinity, 43, 131, 186, 255, "> 2.5 m"],
];

export const heightAboveNearestDrainageColorList = palette.map(
  ([_val, r, g, b, _a, _txt]) => `rgb(${r}, ${g}, ${b})`,
);

export const HeightAboveNearestDrainageLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.heightAboveNearestDrainage")}</b>
      </div>

      {palette.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${a / 255})`)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.heightAboveNearestDrainage")}
        </span>
      </div>
    </div>
  );
};
